<template>
  <div>
    <span v-if="!value?.length">-</span>

    <div
      v-for="{ priorityLevel, icon, viewBox, className } in data"
      :key="priorityLevel"
      class="my-6 break-normal"
    >
      <icon-base :icon="icon" :view-box="viewBox" :class="className" />
    </div>
  </div>
</template>
<script lang="ts" setup>
import { computed } from "vue";

import { priorities } from "@/helpers/constants/priorities";

import IconBase from "@/components/ui/IconBase.vue";

import type { TaskPriorityLevels } from "@/enums/communicationLogs";

const { value } = defineProps<{ value?: TaskPriorityLevels[] }>();

const getPriorityInfo = (priorityLevel: TaskPriorityLevels) => {
  const priority = priorities.find((p) => p.value === priorityLevel);
  return {
    icon: priority?.icon || "",
    viewBox: priority?.viewBox || "",
    class: priority?.class || "",
  };
};

const data = computed(() => {
  if (!value?.length) {
    return [];
  }
  return value.map((priorityLevel) => {
    const info = getPriorityInfo(priorityLevel);
    return {
      priorityLevel,
      icon: info.icon,
      viewBox: info.viewBox,
      className: info.class,
    };
  });
});
</script>
